import React from 'react'

const ProfileSkeletonLoader = () => {
    return (
        <div className="w-full bg-gradient-radial flex-col font-urbanist">
            <section className="w-full flex flex-col lg:pt-15 pt-16 pb-4">
                <div className="container mx-auto px-4 lg:px-10">
                    <div className="w-full text-white font-urbanist flex justify-center items-start pt-5">
                        <div className="relative w-full h-auto flex flex-col items-center rounded-tl-lg rounded-tr-lg animate-pulse">

                            {/* Banner Skeleton */}
                            <div className="w-full h-48 bg-gray-700 rounded-tl-lg rounded-tr-lg"></div>

                            {/* Profile Section */}
                            <div className="w-full flex flex-col border-b-2 border-dashed border-gray-700 pb-12">
                                <div className="flex flex-col sm:flex-row items-start gap-6 p-5 pb-5">

                                    {/* Profile Photo Skeleton */}
                                    <div className="w-44 md:w-52 h-48 md:h-72 rounded-xl overflow-hidden border border-gray-700 bg-gray-800 -mt-24"></div>

                                    {/* Info Skeleton */}
                                    <div className="w-full flex-1 flex-col pt-0 sm:pt-4 space-y-3">
                                        {/* Name + Designation */}

                                        <div className="flex flex-row justify-between mt-0 sm:mt-4">
                                            <div className="w-2/3 flex flex-col items-start mt-3 space-y-2">
                                                <div className="w-1/3 h-6 bg-gray-700 rounded"></div>
                                                <div className="w-1/4 h-4 bg-gray-700 rounded"></div>
                                            </div>
                                            <div className="flex flex-col items-end space-y-2">
                                                <div className="w-16 h-8 bg-gray-700 rounded-xl"></div>
                                                <div className="hidden md:flex flex-row gap-2">
                                                    <div className="w-6 h-6 bg-gray-700 rounded-full"></div>
                                                    <div className="w-6 h-6 bg-gray-700 rounded-full"></div>
                                                    <div className="w-6 h-6 bg-gray-700 rounded-full"></div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Location */}
                                        <div className="flex flex-row items-center mt-3 space-x-2">
                                            <div className="h-6 w-6 bg-gray-700 rounded-full"></div>
                                            <div className="w-1/3 h-4 bg-gray-700 rounded"></div>
                                        </div>

                                        {/* Buttons + Details */}
                                        <div className="flex flex-col space-y-2">
                                            <div className="w-24 h-8 bg-gray-700 rounded-xl"></div>
                                            <div className="w-32 h-8 bg-gray-700 rounded-xl"></div>
                                        </div>

                                    </div>
                                </div>

                                {/* Mobile Buttons Skeleton */}
                                <div className="md:hidden flex flex-col px-5 mt-4 space-y-3">
                                    <div className="w-full h-10 bg-gray-700 rounded-lg"></div>
                                    <div className="w-2/3 h-10 bg-gray-700 rounded-lg"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export { ProfileSkeletonLoader }
